/* 请求接口地址管理 */
console.log("process.env.NODE_ENV", process.env.NODE_ENV);
export var IP = process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : "https://ai-api.bboycc.cn";
export var loginIp ="" //账号密码登录